import React, {useEffect, useState} from "react";
import Bemerkung from "../../../components/bemerkung";
import Api from "../../../Api/api";
import {toast} from "react-toastify";
import {useStateValue} from "../../../states/StateProvider";
import {BeatLoader, ClipLoader} from "react-spinners";
import {Link} from "react-router-dom";
import Reminders from "./reminders";
import {AES, enc} from "crypto-js";
import {IoIosArrowDown, IoIosArrowUp} from "react-icons/io";

const Status = ({notes, company, loadingNotes, count, role, companyID, portal, showReminderSection}) => {
    const [toggle, setToggle] = useState(false)
    const [loading, setLoading] = useState(false)
    const [note, setNote] = useState('')
    const [{secretKey, noteSent, noteRows}, dispatch] = useStateValue();
    const decryptedBytes = localStorage.getItem('user') ? AES.decrypt(localStorage.getItem('user'), secretKey) : false;
    const user = JSON.parse(decryptedBytes.toString(enc.Utf8))
    const userID = user.ID
    const [{collapse2}] = useStateValue();
    const [selectedArtFilter, setSelectedArtFilter] = useState("ALL");

    function save() {
        setLoading(true)
        let data = new FormData()
        data.append('note', note)
        data.append('userID', userID)
        data.append('firma', companyID)
        data.append('portal', portal)
        data.append("art", "ProtokollFP");

        Api().post('/sendNote', data).then(res => {
            setNote('')
            setLoading(false)
            setToggle(!toggle)
            dispatch({type: "SET_NOTE_SENT", item: !noteSent})
            toast.success('Notiz erfolgreich gesendet')
        }).catch(e => {
            toast.error('etwas ist schief gelaufen!!')
            setLoading(false)
            setToggle(!toggle)
        })
    }

    String.prototype.allReplace = function (obj) {
        let retStr = this;
        for (const x in obj) {
            retStr = retStr.replace(new RegExp(x, 'g'), obj[x]);
        }
        return retStr;
    };

    return (
        <>
            {
                showReminderSection &&
                <Reminders id={companyID} userID={userID} role={role} portal={portal}/>
            }

            <div className='flex justify-between bg-white mt-5'>
                <div className='text-left sm:mt-5 lg:mt-0 flex-1'>
                    <button
                        className='px-3 py-2 mx-2 mb-2 hover:bg-lightBlue rounded-3xl bg-mainBlue text-white text-sm'
                        onClick={() => setToggle(!toggle)}
                        hidden={(role === 'ManDGG' || role === 'ManRUV' || role === 'Controller')}
                    >
                        {!toggle ? 'Neue Bemerkung' : 'Abbrechen'}
                    </button>
                    <textarea placeholder='Neue Notiz Bemerkung' hidden={!toggle} rows='3'
                              className='border border-whiteDark w-full rounded-lg p-3'
                              value={note}
                              onChange={(e) => setNote(e.target.value)}
                    />
                    <button
                        className={`${!note || !note.replace(/\s/g, '').length || (role === 'ManRUV' || role === 'ManDGG') ? 'bg-whiteDark cursor-no-drop' : 'bg-mainBlue text-white hover:bg-complete hover:text-text'} px-3 py-2 m-2 rounded-3xl text-sm`}
                        onClick={save}
                        hidden={!toggle}
                        disabled={!note || !note.replace(/\s/g, '').length || (role === 'ManRUV' || role === 'ManDGG')}
                    >
                        {!loading ? 'Senden' : 'Senden...'}
                    </button>
                </div>

                <div onClick={() => dispatch({type: "SET_NOTEROWS", item: 10})} className='flex-shrink-0'>
                    {
                        (count > 3 && noteRows !== 10) &&
                        <div className='px-5 pb-5 cursor-pointer sm:mt-5 lg:mt-0'
                        >
                            <div className='tooltip'>
                                <IoIosArrowDown size='25px'/>
                                <span className='tooltiptextInstant'>Erweitern</span>
                            </div>
                        </div>
                    }
                </div>
                {
                    (count > 0 && noteRows === 10) &&
                    <div onClick={() => dispatch({type: "SET_NOTEROWS", item: 3})} className='flex-shrink-0'>

                        <div className='px-5 pb-5 cursor-pointer sm:mt-5 lg:mt-0'
                        >
                            <div className='tooltip'>
                                <IoIosArrowUp size='25px'/>
                                <span className='tooltiptextInstant'>Erweitern</span>
                            </div>
                        </div>
                    </div>
                }

            </div>
            <div>
                <div className="mt-4 text-sm text-right">
                    <label className="mr-2 font-semibold">Filter:</label>
                    <select
                        className="border border-gray-300 rounded px-2 py-1"
                        value={selectedArtFilter}
                        onChange={(e) => setSelectedArtFilter(e.target.value)}
                    >
                        <option value="Bemerkung">von Benutzer</option>
                        <option value="Automatik">von System</option>
                        <option value="ALL">Alle</option>
                    </select>
                </div>
                {loadingNotes && <div className='centerItemsRelative'><ClipLoader color={'#757575'}/></div>}
                {
                    notes
                        ?.filter(n => {
                            if (selectedArtFilter === "ALL") return true;
                            return n.Typ === selectedArtFilter;
                        })
                        .map((n, index) => (
                            <Bemerkung
                                key={index}
                                note={n.NOTES0.replaceAll('\r\n', '<br>').replaceAll('\r', '<br>').replaceAll('\n', '<br>')}
                                by={n.CREATEDBY}
                                at={n.DATECREATE}
                                isSystem={n.Typ === 'Automatik'}
                            />
                        ))
                }
                {(loadingNotes && noteRows === 10) && <BeatLoader size={10}/>}
            </div>
            {
                (count > 10 && !loadingNotes && noteRows === 10) &&
                <Link to={`/alle-notizen/${portal}/${companyID}`} target={'_blank'}>
                    <button className='bg-mainBlue text-white rounded-2xl px-3 py-2 mt-2 text-sm'> Alles sehen</button>
                </Link>
            }
        </>
    )
}

export default Status
